import * as HLF from "html-living-framework";
import { SceneContainer } from "GameObjects/StoryGame/SceneContainer";
import { Sine, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as Topics from "Data/Topics";

export class SceneSprite extends PIXI.Sprite {

    public z: number = 0;
    public hintScale: number = 1.1; // HACKY

    protected _subscriptions: any[] = [];
    protected _hintTimeline?: TimelineMax;

    private _texturePrefix?: string;

    constructor(texture?: string | PIXI.Texture, anchor?: PIXI.IPoint) {
        super();
        this.setLayoutTexture(texture || PIXI.Texture.EMPTY, anchor ? anchor.x : 0, anchor ? anchor.y : 0);
        this._subscriptions.push(
            PubSub.subscribe(Topics.SHOW_HINT, this.onMessageReceived.bind(this)),
            PubSub.subscribe(Topics.HIDE_HINT, this.onMessageReceived.bind(this)),
            PubSub.subscribe(Topics.HIDE_ALL_HINTS, this.onMessageReceived.bind(this)),
        );
    }

    public static withPrefix(prefix: string): SceneSprite {
        const s = new SceneSprite();
        // factory function can access private fields
        s._texturePrefix = prefix;
        return s;
    }

    public destroy(pDestroyOptions?: any) {
        super.destroy(pDestroyOptions);
        this._subscriptions.forEach(PubSub.unsubscribe);
        this._hintTimeline?.kill();
    }

    public setLayoutTexture(texture: string | PIXI.Texture, anchorX: number, anchorY: number) {
        if(typeof texture === 'string') {
            texture = texture.replace(/\.png$/, '');
            this.name = texture;
            if (this._texturePrefix) {
                texture = this._texturePrefix + texture;
            }
        }
        this.texture = (texture instanceof PIXI.Texture ? texture :
            texture ? HLF.PixiUtils.getTexture(texture) : PIXI.Texture.EMPTY) || PIXI.Texture.EMPTY;
        this.anchor.x = anchorX;
        this.anchor.y = anchorY;
    }

    public setBlendMode(blendMode: string) {
        switch (blendMode) {
            case "multiply":
                this.blendMode = PIXI.BLEND_MODES.MULTIPLY;
                break;
            case "screen":
                this.blendMode = PIXI.BLEND_MODES.SCREEN;
                break;
            case "overlay":
                this.blendMode = PIXI.BLEND_MODES.OVERLAY;
                break;
            case "hardlight":
                this.blendMode = PIXI.BLEND_MODES.HARD_LIGHT;
                break;
            case "lighten":
                this.blendMode = PIXI.BLEND_MODES.LIGHTEN;
                break;
            case "darken":
                this.blendMode = PIXI.BLEND_MODES.DARKEN;
                break;
            case "difference":
                this.blendMode = PIXI.BLEND_MODES.DIFFERENCE;
                break;
            case "add":
                this.blendMode = PIXI.BLEND_MODES.ADD;
                break;
            case "subtract":
                this.blendMode = PIXI.BLEND_MODES.SUBTRACT;
                break;
            case "erase":
                this.blendMode = PIXI.BLEND_MODES.ERASE;
                break;
            // case "invert":
            case "layer":
            case "alpha":
            case "normal":
            default:
                this.blendMode = PIXI.BLEND_MODES.NORMAL;
                break;
        }
    }

    public FadeIn(): void {
        TweenLite.fromTo(this, 1, {pixi: {alpha: 0}}, {pixi: {alpha: 1}});
        this.visible = true;
    }

    public FadeOut(): void {
        this.interactive = false;
        new TimelineLite().to(this, 1, {pixi: {alpha: 0}}).call(()=>{
            this.visible = false;
        })
    }

    protected showHint(pData?: {delay?: number}) {
        if (this._hintTimeline !== undefined) {
            this._hintTimeline.kill();
        }
        else {
            this._hintTimeline = new TimelineMax();
            this._hintTimeline.to(this, 0.5, {pixi: {scale: this.scale.x * this.hintScale}, ease: Sine.easeIn})
            this._hintTimeline.yoyo(true);
            this._hintTimeline.repeat(-1);
            this._hintTimeline.delay(pData?.delay ?? 0);
        }
    }

    protected onMessageReceived(pTopic: string, pData: any) {
        switch (pTopic) {
            case Topics.SHOW_HINT:
                if (pData.target === this) {
                    if(pData.type === "pulse") {
                        this.showHint(pData);
                    }
                }
                break;
            case Topics.HIDE_HINT:
                if (pData === this) {
                    this._hintTimeline?.kill();
                }
                break;
            case Topics.HIDE_ALL_HINTS:
                this._hintTimeline?.kill();
                break;
        }
    }
}